import { isTempId } from 'api/common';

export function getChangeItems(changedFields, data) {
    const form = changedFields['form'] ? { form: data.form } : undefined;
    const pages = changedFields['pages'] ? { pages: data.pages } : undefined;
    const sections = changedFields['sections'] ? { sections: data.sections } : undefined;
    const fields =
        changedFields['fields'] && data.fields.length > 0 ? { fields: data.fields } : undefined;
    const options =
        changedFields['options'] && data.options.length > 0 ? { options: data.options } : undefined;
    const settingsFrom = changedFields['settingsForm'] ? { form: data.settings.form } : undefined;
    const settingsSections = {
        sections: filterEmptyArray(
            changedFields['sectionsIds']
                .map(id => {
                    return data.settings.sections.find(value => value.id === id);
                })
                .filter(elem => elem)
        )
    };

    const settingsFields = {
        fields: filterEmptyArray(
            changedFields['fieldsIds']
                .map(id => {
                    return data.settings.fields.find(value => value.id === id);
                })
                .filter(elem => elem)
        )
    };

    const settingsOptions = {
        options: filterEmptyArray(
            changedFields['optionsIds']
                .reduce((arr, id) => {
                    const result = data.settings.options.find(value => value.id === id);
                    if (result) {
                        arr.push(result);
                    }
                    return arr;
                }, [])
                .filter(elem => elem)
        )
    };
    const promoSettings = changedFields['promoSettings']
        ? { promoSettings: data.promoSettings }
        : undefined;
    const settings =
        settingsFrom ||
        (settingsSections.sections && settingsSections.sections.length > 0) ||
        (settingsFields.fields && settingsFields.fields.length > 0) ||
        (settingsOptions.options && settingsOptions.options.length > 0)
            ? {
                  settings: {
                      ...settingsFrom,
                      ...settingsSections,
                      ...settingsFields,
                      ...settingsOptions
                  }
              }
            : undefined;
    const mergeData = {
        ...form,
        ...pages,
        ...sections,
        ...fields,
        ...options,
        ...settings,
        ...promoSettings
    };

    return mergeData;
}

export function filterTempDelete(data) {
    const {
        sections: sectionSetting,
        fields: fieldSetting,
        options: optionSetting,
        ...other
    } = data.settings;
    const ignoreSectionID = data.sections.reduce((arr, section) => {
        if (section.deleted && isTempId(section.id)) {
            arr.push(section.id);
        }
        return arr;
    }, []);

    const ignoreFieldID = data.fields.reduce((arr, field) => {
        if (ignoreSectionID.includes(field.sectionId) && isTempId(field.id)) {
            arr.push(field.id);
        }
        return arr;
    }, []);

    const ignoreOptionID = data.options.reduce((arr, option) => {
        if ((option.deleted && isTempId(option.id)) || ignoreFieldID.includes(option.fieldId)) {
            arr.push(option.id);
        }
        return arr;
    }, []);
    return {
        ...data,
        pages: data.pages.filter(page => !(page.deleted && isTempId(page.id))),
        sections: data.sections.filter(section => !ignoreSectionID.includes(section.id)),
        fields: data.fields.filter(field => !ignoreFieldID.includes(field.id)),
        options: data.options.filter(option => !ignoreOptionID.includes(option.id)),
        settings: {
            sections: sectionSetting.filter(section => !ignoreSectionID.includes(section.id)),
            fields: fieldSetting.filter(field => !ignoreFieldID.includes(field.id)),
            options: optionSetting.filter(option => !ignoreOptionID.includes(option.id)),
            ...other
        }
    };
}

function filterEmptyArray(array) {
    const isEmpty = array.length === 0;
    if (!isEmpty) {
        return array;
    }
    return undefined;
}
